import { Mentionable } from "../../../../common/sesh_types";
import { PollCreationState } from "../poll_creation";
import React from "react";
import { DashboardUtils } from "../dashboard_utils";
import { SearchableDropdown } from "./searchable_dropdown";
import { MembersSearchDropdown } from "./improved_components/members_search_dropdown";
import { useParams } from "react-router";

type InputType = { user_mentions: string[]; role_mentions: Mentionable[] };

export function MentionsFormFunction(props: {
	roles: Mentionable[] | undefined;
	initial_value: InputType;
	updateFunc: (val: InputType) => void;
	disabled?: boolean;
}) {
	const { disabled } = props;

	let { server_id } = useParams<{
		server_id: string;
	}>();

	return (
		<div>
			<div className={`columns is-multiline !mx-0 !px-0`}>
				<div className="column is-full !mb-0 !pb-0 !px-0">
					<div className="columns is-multiline !mx-0 !px-0">
						<div className="column is-full !mb-0 !pb-0 !px-0">
							<p>Users</p>
						</div>
						<div className="column !mt-0 !pt-0 !px-0">
							<MembersSearchDropdown
								is_disabled={disabled}
								selected_ids={props.initial_value.user_mentions}
								guild_id={server_id}
								onUpdate={(ids) =>
									props.updateFunc({
										user_mentions: ids,
										role_mentions:
											props.initial_value.role_mentions,
									})
								}
							/>
						</div>
					</div>
				</div>
				<div className="column is-full !px-0">
					<div className="columns is-multiline !mx-0 !px-0">
						<div className="column is-full !mb-0 !pb-0 !px-0">
							<p>Roles</p>
						</div>
						<div className="column !mt-0 !pt-0 !px-0">
							<Selector
								disabled={disabled}
								options={props.roles}
								selected_ids={props.initial_value.role_mentions}
								updateFunc={(mentionables) =>
									props.updateFunc({
										user_mentions:
											props.initial_value.user_mentions,
										role_mentions: mentionables,
									})
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function Selector(props: {
	selected_ids: Mentionable[];
	options: Mentionable[];
	longest_name_length?: number;
	disabled: boolean;
	updateFunc: (mentionables: Mentionable[]) => void;
}) {
	const { options, disabled, longest_name_length, selected_ids } = props;

	const loading = !Boolean(options);
	if (loading) {
		return DashboardUtils.RenderLoadingSelect();
	}

	return (
		<SearchableDropdown
			key={loading.toString()}
			handleChange={props.updateFunc}
			longest_name_length={longest_name_length}
			options={options}
			initial_mentions={selected_ids}
			ignore_invalid_permissions={false}
			disabled={disabled}
			loading={!Boolean(options)}
		/>
	);
}
